import React, { MouseEventHandler, useState } from "react";
import styled from "styled-components";
import Backdrop from "./backdrop";
import ReactDOM from 'react-dom'
import CloseImage from '../../assets/icons/xclose.png'

interface BackdropType {
    closeModal: MouseEventHandler,
    confirmModal?: MouseEventHandler,
    title?: string,
    message?: string,
    acceptText?: string,
    cancelText?: string
}

export default function ModalNotification(props: BackdropType) {
    const {title, message, acceptText, cancelText, closeModal, confirmModal} = props;
    const haveButtons:boolean = (acceptText && acceptText.length) || (cancelText && cancelText.length)? true : false;

    const rootBackDrop = document.getElementById('modals');
    return (
        <React.Fragment>
            <Backdrop onclick={props.closeModal}/>
            {ReactDOM.createPortal(
                <ModalContainer>
                    <CloseButton onClick={props.closeModal} src={CloseImage}/>
                    <BoxMain>
                        {title && <Title>{title}</Title>}
                        {message && <Message>{message}</Message>}
                        {haveButtons && (
                        <ButtonArea>
                            {acceptText && <AcceptButton onClick={confirmModal}>{acceptText}</AcceptButton>}
                            {cancelText && <CancelButton onClick={closeModal}>{cancelText}</CancelButton>}
                        </ButtonArea>)}
                    </BoxMain>
                </ModalContainer>,
            rootBackDrop as Element)}
        </React.Fragment>
    );
}

const ModalContainer = styled.div`
    position: fixed;    
    z-index: 1001;
    width: 600px;
    left: calc(100vw/2 - 290px);
    top: calc(100vh/2 - 110px)
`
const BoxMain = styled.div`
    border-radius: 10px;
    background: #F0EEDD;
    text-align: center;
    font-family: 'trade-gothic';
    padding: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
`
const Title = styled.h3`
    font-style: normal;
    font-weight: 700;
    font-size: 21px;
    line-height: 34px;
    text-transform: uppercase;
    color: #84004C;
`
const Message = styled.p`
    font-style: normal;
    font-size: 20px;
    line-height: 25px;
    color: #979696;
    margin: 15px 0px;
`

const ButtonArea = styled.div`
    display: flex;
    justify-content: space-evenly;
`
    const AcceptButton = styled.button`
        box-sizing: border-box;
        background: #261a5f;
        border: 1px solid #261a5f;
        color: #FFFFFF;
        border-radius: 10px;
        padding: 12px 20px;
        font-family: 'trade-gothic';
        font-style: normal;
        font-weight: 700;
        font-size: 21px;
        line-height: 25px;
        text-align: center;
        text-transform: uppercase;
        flex-basis: 120px;
        cursor: pointer;
    `

    const CancelButton = styled.button`
    box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #412ea1;
        color: #412ea1;
        border-radius: 10px;
        padding: 12px 20px;
        font-family: 'trade-gothic';
        font-style: normal;
        font-weight: 700;
        font-size: 21px;
        line-height: 25px;
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        flex-basis: 120px;
    `

const CloseButton = styled.img`
    position: absolute;
    width: 10px;
    height: 10px;
    object-fit: cover;
    top: 15px;
    right: 15px;
    cursor: pointer;
`